<script setup lang="ts">
// Server indicator — DESIGN.md section 9.1, Live match screen. Round-3 feedback item 4
// (2026-08-31): was a small glowing ball shown NEXT TO the avatar; now it's a glowing OUTLINE
// RING wrapped directly AROUND the avatar instead — same amber glow (box-shadow) as before,
// carried over onto the ring rather than a separate dot. Usage: wrap the Avatar in
// `<ServeIndicator :active="snapshot.server === 'left'"><Avatar ... /></ServeIndicator>`.
defineProps<{ active: boolean }>()
</script>

<template>
  <div
    class="inline-flex rounded-full transition-shadow duration-200"
    :class="active ? 'ring-4 ring-amber-300 shadow-[0_0_14px_4px_rgba(252,211,77,0.65)]' : 'ring-4 ring-transparent'"
    :aria-label="active ? 'serving' : undefined"
    :title="active ? 'Serving' : undefined"
  >
    <slot />
  </div>
</template>
